import React, { Component } from 'react';
import { hashHistory } from 'react-router';
import { Picker, List, WhiteSpace, InputItem, Toast } from 'antd-mobile/lib';
import { connect } from 'react-redux';
import Util from '../../util.js';
import { getAllCountry, getCertifcationSuccess,syncAccount, getProvinceCity, provinceCity } from '../../action/investmentAction';
import NavigatorMain from '../NavigatorMain';
import { goHome } from '../../common.js';
import { 
  modifyTaxInfo
} from '../../action/myAssets/userInfoAction.js';

const ToastTime = 2;

const seasons = [
    {
      label: '全部产品',
      value: '2013',
      key:0
    },
    {
      label: '锐意进取型',
      value: '2013',
      key:1
    },
    {
      label: '稳健型',
      value: '2014',
      key:2
    },
];

class ModifyTaxInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yesFlag:false,
      noFlag:true,
      onlyChinese:true,
      noOnlyChinese:false,

      allCountry:[],
      allCountryCode:"",
      allCountryZhCode:"",
      allCountryUsCode:"",
      allCountryUs:[],
      chineseName:"",  /*姓名*/
      familyName:"",  /*姓*/
      englishName:"",  /*名*/
      countryUs:"", /*现居国英文*/
      countryZh:"", /*现居国中文*/
      countryCode:"",
      countryUsCode:"",
      provinceUs:"", /*现居省英文*/
      provinceZh:"", /*现居省中文*/
      cityUs:"", /*现居市英文*/
      cityZh:"", /*现居市中文*/
      birthCityUs:"", /*出生市英文*/
      birthCityZh:"", /*出生市中文*/
      birthCountryUs:"", /*出生国家英文*/
      birthCountryZh:"",  /*出生国家中文*/
      birthCountryCode:"",
      birthCountryUsCode:"",
      addressUs:"",  /*现居地址英文或拼音*/ 
      addressZh:"",  /*现居地址中文*/
      birthAddressUs:"", /*出生地英文或拼音*/
      birthAddressZh:"", /*出生地址中文*/
      provinceCity:"", /*所在城市(选中国)*/
      provinceCode:"",
      cityCode:"",
      isShow: true,

      TaxCountryCode:"",
      onTaxNumber:"有", /*是否有纳税人识别号*/
      TaxNumber:"", /*纳税人识别号*/
      NoTaxNumber:"A", /*无纳税人识别号原因*/
      NoNumberReasion:"", /*具体原因*/

      arrInfo:[],
      i:0,

      agreeIcon:true,
      enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
    };
    this.goCallback=false;
  }
  componentWillUnmount(){
    if (this.goCallback) {
      this.props.location.state.callback ? this.props.location.state.callback() : null
    }
  }
  componentWillMount(){
    let { dispatch } = this.props;
    document.getElementsByTagName('title')[0].innerHTML = "税收居民身份";
    
    dispatch(provinceCity(null));
    dispatch(getAllCountry(this.detailCallBack.bind(this),this))
    dispatch(getProvinceCity((data) => {
      this.setState({
        provinceCity: [data[0].provinceName, data[0].cityList[0].cityName],
        provinceCode: data[0].provinceCode,
        cityCode: data[0].cityList[0].cityCode
      })
    }, () => {
      this.setState({
        provinceCity: ["", ""]
      })
    }));
  }
  goBack(){  
    hashHistory.goBack()
  }
  detailCallBack(data){
    let newDataUS = [].concat(data);
    let newDataZh = [].concat(data);
    let usCode = [];
    let code = [];
    let usAll = [];
    let zhAll = [];
    newDataUS.sort(function(a,b){return a.countryNameUs.localeCompare(b.countryNameUs,'zh-Hans-CN', {sensitivity: 'accent'})});
    newDataZh.sort(function(a,b){return a.countryNameZh.localeCompare(b.countryNameZh,'zh-Hans-CN', {sensitivity: 'accent'})});
    for(let i=0; i<newDataUS.length; i++){
      usCode.push(newDataUS[i].countryCode);
      usAll.push(newDataUS[i].countryNameUs);
    }
    for(let i=0; i<newDataZh.length; i++){
      code.push(newDataZh[i].countryCode);
      zhAll.push(newDataZh[i].countryNameZh);
    }
    this.setState({
      allCountryUs:newDataUS,
      allCountry:newDataZh,
      allCountryCode:code,
      allCountryZhCode:code,
      allCountryUsCode:usCode,
      countryUs:usAll[0],
      countryZh:zhAll[code.indexOf(newDataUS[0].countryCode)],
      countryUsCode:usCode[0],
      countryCode:usCode[0],
      birthCountryUs:usAll[0],
      birthCountryZh:zhAll[code.indexOf(newDataUS[0].countryCode)],
      birthCountryUsCode:usCode[0],
      birthCountryCode:usCode[0],
      TaxCountryCode:code[0],
    })
  }
  addTaxCountry(){
    let _this = this;
    let arr = [];
    arr = arr.concat(this.state.arrInfo)
    let vueKey = this.state.i;
    let ii;
    for(var i=0; i<this.state.i; i++){
      if(arr[i] == undefined){
        let refOne = "taxName" + String(i);
        arr [i] = refOne;
        ii = 0;
        break;
      }
    }
    if(this.state.i < 19){
      if(ii != 0){
        let refTwo = "taxName" + String(vueKey);
        arr[vueKey] = refTwo;
        ii = 1;
      }
    }else{
      Toast.info('最多只能有20个纳税国家', ToastTime);
      return
    }
    this.setState({
      i: this.state.i + ii,
      arrInfo: arr
    })
  }
  deleteTaxCountry(vue){
    let arrTemp =  [];
    arrTemp = arrTemp.concat( this.state.arrInfo )
    arrTemp[vue] = undefined;
    this.setState({
      arrInfo: arrTemp
    })
  }
  successCallBack(){
    hashHistory.push({
        pathname:'/TaxSuccess',
        state:{
          callback:this.props.location.state.callback,route:this.props.location.state.route,name:false
        }
    })
  }
  sureBtn(){
    let that = this;
    let { dispatch } = this.props;
    let { passWord, name, authRequestNo,
      bankAccountName,bankAccountShowNo,
      bankCode,businessType,certNo,certType,
      mobileNo,paymentChannelId,
      actualBeneficiary,actualController,actualBeneficiaryCertType,actualBeneficiaryCertNo,actualControllerCertType,actualControllerCertNo,officialsOrRelatives,address,careerCode,cityCode,provinceCode
    } = this.props.location.state;
    let password = Util.encrypt(passWord);
    let { agreeIcon, yesFlag, noFlag, onlyChinese, noOnlyChinese,
        onTaxNumber, TaxCountryCode, TaxNumber, NoTaxNumber, NoNumberReasion,
        chineseName, countryZh, countryUs, familyName, englishName, birthCountryZh, birthCountryUs, addressZh, addressUs, birthAddressZh, birthAddressUs, provinceUs, provinceZh, cityUs, cityZh, birthCityUs, birthCityZh, countryCode, countryUsCode, birthCountryCode, birthCountryUsCode, provinceCity,
    } = this.state;
    let isAbroad = yesFlag ? true : false;
    let residentType = onlyChinese ? "0" : "2";
    let crsTaxCountry = [];
    let crsTaxIdentifier = [];
    let noIdentifierReason = [];
    let specificReason = [];
    if(!agreeIcon){
      Toast.info('请勾选本人承诺', ToastTime);
      return;
    }
    const cNReg = /^[\u4e00-\u9fa5]+$/; //全中文
    const eNReg = /^[^\u4e00-\u9fa5]+$/; //全英文
    if(noOnlyChinese){
      if(countryUs == "China") {
        if(chineseName == "" || familyName == "" || englishName == "" || countryZh == "" || countryUs == "" || cityUs == "" || provinceCity == "" || birthCountryUs == "" || birthCountryZh == "" || TaxCountryCode == ""){
          Toast.info('请完整填写身份资料', ToastTime);
          return;
        }else {
          if(!cNReg.test(chineseName)) {
            Toast.info("姓名不能包含英文", ToastTime );
            return;
          }
          if(!eNReg.test(familyName)) {
            Toast.info("姓不能包含中文", ToastTime );
            return;
          }
          if(!eNReg.test(englishName)) {
            Toast.info("名不能包含中文", ToastTime );
            return;
          }
          if(onTaxNumber === "有"){
            if(TaxNumber == ""){
              Toast.info('请填写纳税人识别号', ToastTime);
              return;
            }
          }else if(onTaxNumber === "无"){
            if(NoTaxNumber === "请选择"){
              Toast.info('请选择无纳税人识别号原因', ToastTime);
              return;
            }else if(NoTaxNumber === "B"){
              if(NoNumberReasion === ""){
                Toast.info('请填写未取得纳税人识别号具体原因', ToastTime);
                return;
              }
            }
          }
        }
      }else {
        if(chineseName == "" || familyName == "" || englishName == "" || countryZh == "" || countryUs == "" || cityUs == "" || birthCountryUs == "" || birthCountryZh == "" || TaxCountryCode == ""){
          Toast.info('请完整填写身份资料', ToastTime);
          return;
        }else {
          if(!cNReg.test(chineseName)) {
            Toast.info("姓名不能包含英文", ToastTime );
            return;
          }
          if(!eNReg.test(familyName)) {
            Toast.info("姓不能包含中文", ToastTime );
            return;
          }
          if(!eNReg.test(englishName)) {
            Toast.info("名不能包含中文", ToastTime );
            return;
          }
          if(onTaxNumber === "有"){
            if(TaxNumber == ""){
              Toast.info('请填写纳税人识别号', ToastTime);
              return;
            }
          }else if(onTaxNumber === "无"){
            if(NoTaxNumber === "请选择"){
              Toast.info('请选择无纳税人识别号原因', ToastTime);
              return;
            }else if(NoTaxNumber === "B"){
              if(NoNumberReasion === ""){
                Toast.info('请填写未取得纳税人识别号具体原因', ToastTime);
                return;
              }
            }
          }
        }
      }
      if(NoTaxNumber === "请选择"){
        noIdentifierReason.push("");
      }else{
        noIdentifierReason = [NoTaxNumber];
      }
      crsTaxCountry = [TaxCountryCode];
      crsTaxIdentifier.push(TaxNumber);

      specificReason.push(NoNumberReasion);
      var disFlag = false;

      this.state.arrInfo.map((item,key)=>{
        if(item != undefined){
          if(that.refs[item].state.TaxCountryCode == ""){
            Toast.info("纳税居民国" + String(key+2) + "不能为空", ToastTime);
            disFlag = true;
            return false;
          }else if(that.refs[item].state.onTaxNumber == "有"){
            if(that.refs[item].state.TaxNumber === ""){
              Toast.info("请填写纳税居民国" + String(key+2) +  "纳税人识别号", ToastTime);
              disFlag = true;
              return false;
            }
          }else if(that.refs[item].state.onTaxNumber === "无"){
            if(that.refs[item].state.NoTaxNumber === "请选择"){
              Toast.info("请选择纳税居民国" + String(key+2) + "无纳税人识别号原因", ToastTime);
              disFlag = true;
              return false;
            }else if(that.refs[item].state.NoTaxNumber === "B"){
              if(that.refs[item].state.NoNumberReasion === ""){
                Toast.info("请填写纳税居民国" + String(key+2) + "未取得纳税人识别号原因", ToastTime);
                disFlag = true;
                return false;
              }
            }
          }
          if(that.refs[item].state.NoTaxNumber === "请选择"){
            noIdentifierReason.push("");
          }else{
            noIdentifierReason.push(that.refs[item].state.NoTaxNumber);
          }
          crsTaxCountry.push(that.refs[item].state.TaxCountryCode);
          crsTaxIdentifier.push(that.refs[item].state.TaxNumber);
          specificReason.push(that.refs[item].state.NoNumberReasion);
        }
      })
      if(disFlag){
        return false;
      }
      crsTaxCountry = crsTaxCountry.join();
      crsTaxIdentifier = crsTaxIdentifier.join();
      noIdentifierReason = noIdentifierReason.join();
      specificReason = specificReason.join();

      let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
      let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;

      let allInObj = {
        isAbroad,residentType,
        chineseName:chineseName,
        familyName,
        englishName,
        countryZh:countryCode,
        countryUs:countryUsCode,
        provinceUs:provinceUs,
        provinceZh:countryUs == "China" ? this.state.provinceCode : provinceZh,
        cityUs:cityUs,
        cityZh:countryUs == "China" ? this.state.cityCode : cityZh,
        birthCityUs:birthCityUs,
        birthCityZh:birthCityZh,
        postCode:"",
        email:"",
        addressZh:addressZh,
        addressUs:addressUs,
        birthCountryZh:birthCountryCode,
        birthCountryUs:birthCountryUsCode,
        birthAddressZh:birthAddressZh,
        birthAddressUs:birthAddressUs,
        crsTaxCountry:crsTaxCountry,
        crsTaxIdentifier:crsTaxIdentifier,
        noIdentifierReason:noIdentifierReason,
        specificReason:specificReason
      }
      console.log(allInObj)
      dispatch(modifyTaxInfo(allInObj,()=>{
        let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
        
        if(route) {
          this.goCallback=true;
          hashHistory.go(-2);
        }
      },(msg)=>{
        Toast.info(msg, Util.ToastTime);
      }))

    }else{
      if(!yesFlag && !noFlag){
        Toast.info("请选择是否有向向其他国家纳税的活动", ToastTime);
        return;
      }else if(!onlyChinese && !noOnlyChinese){
        Toast.info("请选择本人申明", ToastTime);
        return;
      }
  

      let obj = {
        isAbroad,
        residentType,
      }
      dispatch(modifyTaxInfo(obj,()=>{
        let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
        
        if(route) {
          this.goCallback=true;
          hashHistory.go(-2);
        }
      },(msg)=>{
        Toast.info(msg, ToastTime);
      }))
    }
    
  }
  render() {
    let arrUs = [];
    let arrZh = [];
    let usAll = [];
    let zhAll = [];
    let arrProc = [];
    if(this.state.allCountry.length > 0 && this.state.allCountryUs.length > 0) {
      for(let i = 0; i < this.state.allCountry.length; i++) {
        arrUs.push({
          label: this.state.allCountryUs[i].countryNameUs,
          value: this.state.allCountryUs[i].countryCode
        });
        arrZh.push({
          label: this.state.allCountry[i].countryNameZh,
          value: this.state.allCountry[i].countryCode
        });
        usAll.push(this.state.allCountryUs[i].countryNameUs);
        zhAll.push(this.state.allCountry[i].countryNameZh);
      }
    }
    if(this.props.provinceCity != null) {
      for(let i = 0; i < this.props.provinceCity.length; i++) {
        let obj = {};
        let obj2 = [];
        obj.label = this.props.provinceCity[i].provinceName;
        obj.value = this.props.provinceCity[i].provinceCode;
        for(let k = 0; k < this.props.provinceCity[i].cityList.length; k++) {
          obj2.push({
            label: this.props.provinceCity[i].cityList[k].cityName,
            value: this.props.provinceCity[i].cityList[k].cityCode
          });
        }
        obj.children = obj2;
        arrProc.push(obj);
      }
    }

    let { yesFlag, noFlag, onlyChinese, noOnlyChinese, onTaxNumber, NoTaxNumber,
        chineseName, countryZh, countryUs, familyName, englishName, birthCountryZh, birthCountryUs, addressZh, addressUs, birthAddressZh, birthAddressUs, provinceUs, provinceZh, cityUs, cityZh, birthCityUs, birthCityZh, countryCode, countryUsCode, birthCountryCode, birthCountryUsCode, TaxCountryCode, provinceCity,
        agreeIcon,
    } = this.state;
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="header">
            <div><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div>税收居民身份</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div className='content' style={{ paddingBottom:"40px" }}>
          <div className="TaxBgMain">
            根据《非居民金融账户涉税信息尽职调查管理办法》规定，请您补充以下资料，阅读并勾选承诺内容:
          </div>
          <div className="yesOrNoTax">
            是否持有其他国家或地区的国籍或永久居留权,或在过去一年中在其他国家居住或工作,或从事其他有义务向别国缴纳税收的活动？
          </div>
          <div  className={ yesFlag ? "chooseYes" : "chooseNO" } onClick= {()=>{ this.setState({ yesFlag:true, noFlag:false, noOnlyChinese: true, onlyChinese:false }) }} >
            <span></span><span>是</span>
          </div>
          <div className={ noFlag ? "chooseYes" : "chooseNO" } onClick={ ()=>{ this.setState({ noFlag:true, yesFlag:false, onlyChinese: true, noOnlyChinese:false }) } }>
            <span></span><span>否</span>
          </div>
          <div style={{ height:'0.9rem', paddingLeft:'13px', lineHeight:'1rem', fontSize:'13px'}}>
            本人申明为
          </div>

          <div  className={ onlyChinese ? "chooseYes" : "chooseNO" } onClick={ ()=> { this.setState({ onlyChinese: true, noOnlyChinese:false, resultShow:true, }) } }>
            <span></span><span>仅为中国税收居民</span>
          </div>
          <div className={ noOnlyChinese ? "chooseYes" : "chooseNO" } onClick={ ()=> { this.setState({ noOnlyChinese:true, onlyChinese:false, resultShow:true, }) } } >
            <span></span><span>即是中国税收居民又是其他国家（地区）税收居民</span>
          </div>
          {
            noOnlyChinese?
            <div className="crsAdd">
              <div style={{ height:'0.9rem', paddingLeft:'13px', lineHeight:'1rem', fontSize:'13px'}}>
                补充身份资料
              </div>
              <div className="taxInputClass">
                <span>姓名（中文）</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入姓名" value={ chineseName } onChange={ (e) =>{ this.setState({ chineseName: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>
              <div className="taxInputClass">
                <span>姓 (英文或拼音)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入姓" value = { familyName } onChange={ (e) =>{ this.setState({ familyName: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>
              <div className="taxInputClass">
                <span>名 (英文或拼音)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入名" value = { englishName } onChange={ (e) =>{ this.setState({ englishName: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>

              <div style={{ height:'0.9rem', paddingLeft:'13px', lineHeight:'1rem', fontSize:'13px'}}>
                现居地址 (英文或拼音)
              </div>
              <div className="PickerWrap">
                <Picker data={arrUs} cols={1} className="forss" title="选择国家" value={ [countryUsCode] }  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ countryUsCode:e[0], countryCode:e[0], countryUs: usAll[this.state.allCountryUsCode.indexOf(e[0])], countryZh: zhAll[this.state.allCountryZhCode.indexOf(e[0])] }) } >
                  <List.Item arrow="horizontal" >国家</List.Item>
                </Picker>
              </div>
              <div className="taxInputClass">
                <span>省 (选填)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入省" value = { provinceUs } onChange={ (e) =>{ this.setState({ provinceUs: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>
              <div className="taxInputClass">
                <span>市</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入市" value = { cityUs } onChange={ (e) =>{ this.setState({ cityUs: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>
              <div className="taxInputClass">
                <span>详细地址 (选填)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入详细地址" value = { addressUs } onChange={ (e) =>{ this.setState({ addressUs: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>

              <div className={countryUs == "China" ? "" : "ifChina"} style={{ height:'0.9rem', paddingLeft:'13px',paddingRight: '13px', lineHeight:'1rem', fontSize:'13px'}}>
                <span>现居地址 (中文)</span>
                {
                  countryUs == "China" ? 
                  null
                  :
                  <span>此项选填</span>
                }
              </div>
              <div className="PickerWrap">
                <Picker data={arrZh} cols={1} className="forss" title="选择国家" value={ [countryCode] }  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ countryCode:e[0], countryUsCode:e[0], countryUs: usAll[this.state.allCountryUsCode.indexOf(e[0])], countryZh: zhAll[this.state.allCountryZhCode.indexOf(e[0])] }) } >
                  <List.Item arrow="horizontal" >国家</List.Item>
                </Picker>
              </div>
              {
                countryUs == "China" ? 
                <div className="PickerWrap">
                  <Picker data={arrProc} cols={2} className="forss" title="选择城市" value={ [this.state.provinceCode, this.state.cityCode] }  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ provinceCode:e[0], cityCode:e[1] }) } >
                    <List.Item arrow="horizontal" >所在城市</List.Item>
                  </Picker>
                </div>
                :
                <div className="taxInputClass">
                  <span>省</span>
                  <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入省" value = { provinceZh } onChange={ (e) =>{ this.setState({ provinceZh: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
                </div>
              }
              {
                countryUs == "China" ? null
                :
                <div className="taxInputClass">
                  <span>市</span>
                  <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入市" value = { cityZh } onChange={ (e) =>{ this.setState({ cityZh: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
                </div>
              }
              <div className="taxInputClass">
                {
                  countryUs == "China" ? 
                  <span>详细地址 (选填)</span>
                  :
                  <span>详细地址</span>
                }
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入详细地址" value = { addressZh } onChange={ (e) =>{ this.setState({ addressZh: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>

              <div style={{ height:'0.9rem', paddingLeft:'13px', lineHeight:'1rem', fontSize:'13px'}}>
                出生地 (英文或拼音)
              </div>
              <div className="PickerWrap">
                <Picker data={arrUs} cols={1} className="forss" title="选择国家" value={ [birthCountryUsCode] }  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ birthCountryUsCode:e[0], birthCountryCode:e[0], birthCountryUs: usAll[this.state.allCountryUsCode.indexOf(e[0])], birthCountryZh: zhAll[this.state.allCountryZhCode.indexOf(e[0])] }) } >
                  <List.Item arrow="horizontal" >国家</List.Item>
                </Picker>
              </div>
              <div className="taxInputClass">
                <span>市 (选填)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入市" value = { birthCityUs } onChange={ (e) =>{ this.setState({ birthCityUs: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>
              <div className="taxInputClass">
                <span>详细地址 (选填)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入详细地址" value = { birthAddressUs } onChange={ (e) =>{ this.setState({ birthAddressUs: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>

              <div style={{ height:'0.9rem', paddingLeft:'13px', lineHeight:'1rem', fontSize:'13px'}}>
                出生地 (中文)
              </div>
              <div className="PickerWrap">
                <Picker data={arrZh} cols={1} className="forss" title="选择国家" value={ [birthCountryCode] }  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ birthCountryCode:e[0], birthCountryUsCode:e[0], birthCountryUs: usAll[this.state.allCountryUsCode.indexOf(e[0])], birthCountryZh: zhAll[this.state.allCountryZhCode.indexOf(e[0])] }) } >
                  <List.Item arrow="horizontal" >国家</List.Item>
                </Picker>
              </div>
              <div className="taxInputClass">
                <span>市 (选填)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入市" value = { birthCityZh } onChange={ (e) =>{ this.setState({ birthCityZh: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>
              <div className="taxInputClass">
                <span>详细地址 (选填)</span>
                <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入详细地址" value = { birthAddressZh } onChange={ (e) =>{ this.setState({ birthAddressZh: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>

              <div style={{ hegiht:"0.18rem"}}></div>

              <div>
                <div className="taxCountryTitle">
                  <span>纳税居民国1</span>
                  <span><a></a></span>
                </div>

                <div className="PickerWrap">
                  <Picker data={arrZh} cols={1} className="forss" title="选择国家" value={[TaxCountryCode]}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ TaxCountryCode:e[0] }) } >
                    <List.Item arrow="horizontal" >税收居民国(地区)</List.Item>
                  </Picker>
                </div>
                <div className="PickerWrap">
                  <Picker data={HoverNoTaxNumber} cols={1} className="forss" title="请选择" value={[this.state.onTaxNumber]}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ onTaxNumber:e[0] }) } >
                    <List.Item arrow="horizontal" >是否有纳税人识别号</List.Item>
                  </Picker>
                </div>
                {
                  onTaxNumber === "有"?
                    <div className="taxInputClass">
                      <span>纳税人识别号</span>
                      <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入识别号" value={this.state.TaxNumber } onChange={ (e) =>{ this.setState({ TaxNumber: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
                    </div>
                  :
                  <div>
                    <div className="PickerWrap">
                      <Picker data={NoTaxNumberArr} cols={1} className="forss" title="选择原因" value={[this.state.NoTaxNumber]}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ NoTaxNumber:e[0] }) } >
                        <List.Item arrow="horizontal" >无纳税人识别号原因</List.Item>
                      </Picker>
                    </div>
                    {
                      NoTaxNumber === "B"?
                      <div className="taxInputClass">
                        <span>具体原因</span>
                        <input onFocus={() => {this.setState({ isShow: false })}} onBlur={() => {this.setState({ isShow: true })}} autocomplete="off" placeholder="请输入具体原因" value={this.state.NoNumberReasion}  onChange={ (e) =>{ this.setState({ NoNumberReasion: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
                      </div>:null
                    }
                     
                  </div>
                } 
              </div>

              {
                  this.state.arrInfo.map((item,i) =>  {
                      let index = i;

                      if(item != undefined){
                        return(
                          <TaxCountry key={ "item" + i } allCountry={ arrZh } ref={item} this = {this} index = { index } />
                        )
                      }
                    }
                  )
              }
             
              <div style={{ padding:"0 13px 0 0.26em", marginTop:'0.3rem' }}>
                <div onClick={ () => this.addTaxCountry() } style={{ height:'0.8rem', display: "-webkit-flex", borderRadius:40, border:"1px solid #ff9536", WebkitJustifyContent:'center', WebkitAlignItems:'center'}}>
                  <span style={{color:'#ff9536'}}>+添加其他纳税居民国</span>
                </div>
              </div>
            </div>: null
          }


          <div className="toSureAll">
            <div className={ agreeIcon ? "yesSure" : "noSure" }> <span onClick={ ()=> { this.setState({ agreeIcon:!this.state.agreeIcon }) } }></span> </div>
            <div className="sureContent">
            "本人确认上述所提供的信息真实、准确、完整、合法、有效，如有伪造
                、欺诈，提供虚假信息等行为，本人自愿承担法律责任。当有关资料信心发生变更时，本人将在
                30日内书面通知华夏基金办理信息更改手续，本人自愿承担因未履行上述义务照成的风险和损失，华夏基金对本人遭受的损失不承担任何责任。"
            </div>
          </div>
          </div>
          {
            this.state.isShow ?
            <div className="FixedBottomHave" style={{ WebkitJustifyContent:"center" }} onClick={ ()=> this.sureBtn() } >
              <div>我已阅读并同意</div>
            </div>
            :
            null
          }
        </div>
    );
  }
}

const HoverNoTaxNumber = [
    {
      label: '有',
      value: '有',
      key:0
    },
    {
      label: '无',
      value: '无',
      key:1
    }
];

const NoTaxNumberArr = [
    {
      label: '居民国不发放识别号',
      value: 'A',
      key:0
    },
    {
      label: '未取得纳税人识别号',
      value: 'B',
      key:1
    }
];

class TaxCountry extends Component{
  constructor(props) {
    super(props);
    this.state = {
      TaxCountryCode:this.props.this.state.allCountryCode[0],
      onTaxNumber:"有", /*是否有纳税人识别号*/
      TaxNumber:"", /*纳税人识别号*/
      NoTaxNumber:"A", /*无纳税人识别号原因*/
      NoNumberReasion:"", /*具体原因*/
    }
  }
  render(){
    let { onTaxNumber, NoTaxNumber} = this.state;
    let { allCountry } = this.props;
    let thisPro = this.props.this;
    let index = this.props.index + 2
    return(
      <div>
        <div className="taxCountryTitle">
          <span>{"纳税居民国" + index}</span>
          <span onClick={ ()=>{ thisPro.deleteTaxCountry(this.props.index) }} ><a>删除</a></span>
        </div>

        <div className="PickerWrap">
          <Picker data={allCountry} cols={1} className="forss" title="选择国家" value={[this.state.TaxCountryCode]}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ TaxCountryCode:e[0] }) } >
            <List.Item arrow="horizontal" >税收居民国(地区)</List.Item>
          </Picker>
        </div>
        <div className="PickerWrap">
          <Picker data={HoverNoTaxNumber} cols={1} className="forss" title="请选择" value={[this.state.onTaxNumber]}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ onTaxNumber:e[0] }) } >
            <List.Item arrow="horizontal" >是否有纳税人识别号</List.Item>
          </Picker>
        </div>
        {
          onTaxNumber === "有"?
            <div className="taxInputClass">
              <span>纳税人识别号</span>
              <input autocomplete="off" placeholder="请输入识别号" value={this.state.TaxNumber } onChange={ (e) =>{ this.setState({ TaxNumber: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
            </div>
          :
          <div>
            <div className="PickerWrap">
              <Picker data={NoTaxNumberArr} cols={1} className="forss" title="选择原因" value={[this.state.NoTaxNumber]}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ NoTaxNumber:e[0] }) } >
                <List.Item arrow="horizontal" >无纳税人识别号原因</List.Item>
              </Picker>
            </div>
            {
              NoTaxNumber === "B"?
              <div className="taxInputClass">
                <span>具体原因</span>
                <input autocomplete="off" placeholder="请输入具体原因" value={this.state.NoNumberReasion}  onChange={ (e) =>{ this.setState({ NoNumberReasion: e.target.value})  } } style={{ WebkitFlex:1,textAlign:'right' }} />
              </div>:null
            }
             
          </div>
        }
        
      </div>
    )
  }
}



function mapStateToProps(state, ownProps) {
  return {
    provinceCity: state.provinceCity,
    // userHasInvested:state.userHasInvested,
    // inNeedUpdate:state.inNeedUpdate,
    // payLoading:state.riskInPay.payLoading,
  }
}

export default connect(mapStateToProps)(ModifyTaxInfo);



// WEBPACK FOOTER //
// ./src/components/fundDetail/ModifyTaxInfo.js